import React, { useState } from "react";
import LocationTag from "./LocationTag";
import HorizontalScroll from "../../../global/ui/HorizontalScroll";
import { emptyFunction } from "../../../utils";

interface ILocationCardStrip {
    items: Array<any>;
    onCardClick: (data: any) => void;
    onShare: (data: any) => void;
    onAsign: (data: any) => void;
    onScriptAsign: (data: any) => void;
    vaultType: any
    hideAsign?: any;
    onReachEnd?: () => void
}

const LocationCardStrip = ({ items, onCardClick, onShare, vaultType, onAsign, hideAsign, onReachEnd, onScriptAsign }: ILocationCardStrip) => {

    const [openMenuId, setOpenMenuId] = useState<number | null>(null);

    return (
        <HorizontalScroll
            onScroll={emptyFunction}
            onReachEnd={onReachEnd}
            onReachStart={emptyFunction}
            className="sv-strip"
        >
            {items?.map(item => (
                <div key={item?.id} className="sv-card" onClick={() => {
                    if (openMenuId) {
                        setOpenMenuId(null)
                        return
                    }
                    onCardClick?.(item)
                }}>
                    <img src={item?.location?.thumbnail || '/assets/images/yellow-6th.png'} alt={item?.location?.name} className="sv-card__img" />
                    <div className="sv-card__overlay" />
                    {item?.location?.scouting_tags && <LocationTag variant={item?.location?.scouting_tags} className="tag--overlay" />}
                    <div className="sv-card__info">
                        <span className="sv-card__name">{item?.location?.name}</span>
                        <span className="sv-card__address">{item?.location?.address}</span>
                    </div>
                    <div style={{ position: 'absolute', right: 10, bottom: 10, zIndex: 99 }} className="lv-card__menu-wrap">
                        <button
                            className="lv-card__menu-btn"
                            onClick={e => {
                                e.stopPropagation();
                                setOpenMenuId(openMenuId === item?.location?.id ? null : item?.location?.id);
                            }}
                        >
                            <img src='/assets/images/dots-vertical-rounded.svg' alt='more' />
                        </button>
                        {openMenuId === item?.location?.id && (
                            <div className="lv-card__menu-dropdown">
                                {!hideAsign &&
                                    <>
                                        <button
                                            onClick={() => {
                                                setOpenMenuId(null)
                                                onAsign?.(item);
                                            }}
                                            className="lv-card__menu-item">
                                            <img src='/assets/images/plus-icon-1.svg' />
                                            {vaultType == 'myvault' ? 'Add to production' : 'Assign Location'}
                                        </button>
                                        {vaultType != 'myvault' &&
                                            <button
                                                onClick={() => {
                                                    setOpenMenuId(null)
                                                    onScriptAsign(item)
                                                }}
                                                className="lv-card__menu-item">
                                                <img src='/assets/images/perscript-active.svg' />
                                                Assign to script
                                            </button>
                                        }
                                    </>
                                }
                                {vaultType == 'myvault'
                                    ?
                                    null
                                    :
                                    <button
                                        onClick={() => {
                                            setOpenMenuId(null)
                                            onShare?.(item)
                                        }}
                                        className="lv-card__menu-item"
                                    >
                                        <img src='/assets/images/share-blue.svg' />
                                        Share
                                    </button>
                                }
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </HorizontalScroll>
    )
};

export default LocationCardStrip